import BoldNode from './BoldNode'
import BoldButton from './BoldButton'

const TYPE = 'Bold'
const TRIGGER_KEY = 'b'

const hasBold = state => state.marks.count() && state.marks.some(mark => mark.type === TYPE)

const BoldSchema = {
  marks: {
    Bold: BoldNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .toggleMark(TYPE)
    .focus()
    .apply()
}

const BoldPlugin = options => {
  return {
    schema: BoldSchema,

    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasBold,
  onClickButton,
  BoldPlugin,
  BoldSchema,
  BoldNode,
  BoldButton
}



// WEBPACK FOOTER //
// ./src/components/BoldSlatePlugin/BoldSlatePluginContainer.js